import { fg } from '@atlassian/jira-feature-gating';
import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsCustomerConversationsAnalyticsRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsCustomerConversationsAnalyticsRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { customerConversationsAnalyticsRoutePageEntryPoint } from './ui/customer-conversations-analytics/customerConversationsAnalyticsRoutePageEntryPoint.tsx';

export const helpCenterSettingsCustomerConversationsAnalyticsRouteEntry: Route = createEntry(
	helpCenterSettingsCustomerConversationsAnalyticsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.customer-conversations-analytics',
		layout: globalLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		entryPoint() {
			return fg('sql_gen_enable_csm_reporting')
				? customerConversationsAnalyticsRoutePageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [...getNavigationResources(), customerExperiencesNavigationResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
